import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { CircularProgress, Box } from '@mui/material';

const ProtectedAdminRoute = ({ children }) => {
    const { user } = useAuth();
    
    if (!user) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    const isAdmin = user?.membershipType === 'Membership Administrator' &&
                    user?.membershipEndDate &&
                    new Date(user.membershipEndDate) > new Date();

    if (!isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedAdminRoute; 